import { TResponse_ReportMetricColumnConfig } from '@monorepo/types';
import { IAppState } from '../..';

import {
  ReportAdavanceSettingActionTypes,
  TMetricColumnReorderInfo,
  TReportAdavanceAction,
} from './adavance-setting.action';

const initialState: IAppState['reports'] = {
  adavanceMetricSetting: {
    headerColumns: [],
    expressionRestrictions: {
      allowedOperators: [],
      allowedOperands: [],
    },
  },
};

export const reportActionReducer = (state = initialState, action: TReportAdavanceAction) => {
  switch (action.type) {
    case ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfigSuccess:
      return { ...state, adavanceMetricSetting: action.metricColumnConfig };
    case ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfigFailure: {
      return {
        ...state,
        adavanceMetricSetting: {
          headerColumns: [],
          expressionRestrictions: {
            allowedOperators: [],
            allowedOperands: [],
          },
        },
      };
    }
    case ReportAdavanceSettingActionTypes.AdvanceReportMetricColumnUpdate:
      return {
        ...state,
        adavanceMetricSetting: {
          ...state.adavanceMetricSetting,
          headerColumns: state.adavanceMetricSetting.headerColumns.some((v) => v.id === action.payload.id)
            ? state.adavanceMetricSetting.headerColumns.map((col) => ({
                ...col,
                ...(col.id === action.payload.id ? action.payload : {}),
              }))
            : [...state.adavanceMetricSetting.headerColumns, action.payload],
        },
      };
    case ReportAdavanceSettingActionTypes.MetricColumnReOrder: {
      return {
        ...state,
        adavanceMetricSetting: {
          ...state.adavanceMetricSetting,
          headerColumns: reorderExpression(state.adavanceMetricSetting.headerColumns, action.payload),
        },
      };
    }
    case ReportAdavanceSettingActionTypes.SaveMetricExpressionDisplayNameChange: {
      return {
        ...state,
        adavanceMetricSetting: {
          ...state.adavanceMetricSetting,
          headerColumns: state.adavanceMetricSetting.headerColumns.map((s) => {
            const { displayName, enabled } = action.metricExpressions.find((v) => v.id === s.id) || s;
            return {
              ...s,
              displayName,
              enabled,
            };
          }),
        },
      };
    }
    case ReportAdavanceSettingActionTypes.SaveSubTotalDisplayNameChange: {
      return {
        ...state,
        adavanceMetricSetting: {
          ...state.adavanceMetricSetting,
          subtotalConfigs: state.adavanceMetricSetting.subtotalConfigs
            ? state.adavanceMetricSetting.subtotalConfigs.map((s) => {
                const { displayName, enabled } = action.subTotalColumns.find((v) => v.id === s.id) || s;
                return {
                  ...s,
                  displayName,
                  enabled,
                };
              })
            : undefined,
        },
      };
    }
    default:
      return state;
  }
};

const reorderExpression = (
  columns: TResponse_ReportMetricColumnConfig['headerColumns'],
  moveMetric: TMetricColumnReorderInfo,
) => {
  const { index, direction } = moveMetric;

  const indexToMove =
    direction === 1
      ? getFirstMetricExpressionAfterPivot(columns, index)
      : getFirstMetricExpressionBeforePivot(columns, index);
  return swapArrayElement(columns, index, indexToMove);
};
//
const getFirstMetricExpressionBeforePivot = (
  columns: TResponse_ReportMetricColumnConfig['headerColumns'],
  index: number,
) => {
  if (index === 0) {
    return 0;
  }

  for (let i = index - 1; i >= 0; i--) {
    if (columns[i].columnType === 'METRIC') {
      return i;
    }
  }
  return index;
};

//Below
const getFirstMetricExpressionAfterPivot = (
  columns: TResponse_ReportMetricColumnConfig['headerColumns'],
  index: number,
) => {
  if (index >= columns.length - 1) {
    return columns.length - 1;
  }

  for (let i = index + 1; i < columns.length; i++) {
    if (columns[i].columnType === 'METRIC') {
      return i;
    }
  }
  return index;
};

//swapArrayElement
const swapArrayElement = <T>(columns: T[], index1: number, index2: number) => {
  const columnsCopy = [...columns];
  [columnsCopy[index1], columnsCopy[index2]] = [columnsCopy[index2], columnsCopy[index1]];
  return columnsCopy;
};
